/**
 * Brazilian Portuguese (pt-BR) mappings for MobileNavigation
 */

export const mobileNavigationPtBR = {
  // User stats and display
  "points": "pontos",
  "today": "hoje",
  "Novice Oracle": "Oráculo Iniciante",
  "Daily Streak": "Sequência Diária",
  "days": "dias",
  
  // Pro status
  "PRO": "PRO",
  "Upgrade to Pro?": "Atualizar para Pro?",
  
  // Navigation items
  "Home": "Início",
  "Chat": "Conversa",
  "AI Exchange": "Câmbio de IA",
  "Sports Hub": "Central de Esportes",
  "Community": "Comunidade",
  "Settings": "Configurações",
  "Upgrade": "Atualizar",
  "Help": "Ajuda",
  "About Us": "Sobre Nós",
  "Chat Archive": "Arquivo de Conversas",
  "Sign Out": "Sair",
  
  // Footer
  "Mobile Version 2.0.0": "Versão Mobile 2.0.0",
  "© 2025 PickStar": "© 2025 PickStar",
};